<section class="page-wrapper">
    <article class="heading-portion">
        <h3 class="heading-text mt-2">{{data.mainHeading}}</h3>
        <p class="heading-sub-text" *ngIf="data.infoMessage" [class.red]="data.infoMessageType == 'error'">
            {{data.infoMessage}}
        </p>
        <p class="heading-sub-text">
            {{data.subHeading}}
            <strong *ngIf="data.mobileNumber" class="black">{{data.mobileNumber}}</strong>
            <strong *ngIf="data.email">{{data.email}}</strong>
        </p>
    </article>
    <article class="body-portion">
        <div class="otp-inputs mb-3">
            <div class="otp-inputs">
                <input *ngFor="let digit of otpDigits; let i = index" type="number" maxlength="1"
                    onKeyPress="if(this.value.length==1) return false;" id="otp-input-{{i}}" (input)="focusNext(i)"
                    [(ngModel)]="otp[i]" class="font-md-larger text-center" />
            </div>
        </div>
        <div class="resendOtpText">
            <div *ngIf="timerValue > 0" class="color_gray">
                Didn't receive the OTP? Retry in
                <strong style="color: #666666">00:{{ timerValue }}s</strong>
            </div>
            <div *ngIf="timerValue == 0" class="color_gray">
                Didn't recieve OTP?
                <a (click)="OnResendOtpClicked()" style="cursor: pointer">click here</a>
                to resend OTP
            </div>
        </div>
    </article>
    <article class="footer mt-4 pt-4 d-flex">
        <button class="btn-outline" (click)="onBackButtonClicked()">
            {{data.BackButtonText}}
        </button>
        <button class="btn-normal" (click)="onVerifyClicked()" [disabled]="isVerifyButtonDisabled()">
            {{data.submitButtonText}}
        </button>
    </article>
</section>